import store from '@/store'
import SamplingService from '@/service/SamplingService';

// @TODO: moduł, który nabardziej wymaga refaktoryzacji. 
// Zamknąć kroki w czymś w rodzaju AppContext, AppService, etc.

export default async function(to, from, next) {
    console.log('[App Guard]:[ASYNC] Guarding start.')

    const isInitialized = store.getters['apiAuth/isInitialized']

    if (!isInitialized) {
        store.dispatch('siteLoader/open', 'master', { root: true })

        await store.dispatch('apiStudent/checkLoginState')

        try {
            await store.dispatch('apiCampaign/resolveCampaign', {}, { root: true }) // @TODO: + resolve campaign consents

            // @TODO: w tym miejscu przesyłamy dane kampanii do consentsResolvera
            
            const data = await store.dispatch('apiCustomer/get')

            if (data.data) {
                store.commit('apiCustomer/setCustomerData', data.data, { root: true })
                store.commit('apiAuth/setIsAuth', true)

                store.dispatch('consentsResolver/resolve', { 
                    consents: data.data.marketingConsents,
                    leaflet: data.data.paperBrochure
                }, { root: true })
            }
        }
        catch(e) {
            console.log('User is not logged in yet.')
        }

        store.dispatch('apiAuth/init')
    }

    document.title = to.meta.title || ''

    if (SamplingService.shouldRedirectToSamplingOnce(store)) {
        console.log('[Router middleware] Redirected to sampling page.')

        const campaignData = store.getters['apiCampaign/campaign']

        if (!campaignData) {
            return next({ name: 'index' })
        }

        return next({ 
            name: 'sampling', 
            params: { 
                token: campaignData.token
            } 
        })
    }

    console.log('[App Guard]:[ASYNC] Guarded.')
    
    next()
}